import { Routes } from '@angular/router';
import { AuthGuard } from '@i7/shared';

export const cntRoutes: Routes = [
  {
    path: 'cadastro-generico',
    loadChildren: () =>
      import(
        '../pages/cad/cadastro-generico/cadastro-generico.module'
      ).then((module) => module.CadastroGenericoModule),
    canActivate: [AuthGuard],
  },
  {
    path: "contrato",
    loadChildren: () =>
      import("../pages/cnt/contrato/contrato-routing.module").then(
        (module) => module.ContratoRoutingModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'indice',
    loadChildren: () =>
      import('../pages/bas/indice/indice.module').then(
        (module) => module.IndiceModule
      ),
    canActivate: [AuthGuard],
  }
];
